export default {
    SET_CONTRACTS(state, contractsList) {
        state.contractsList = [...contractsList];
    },
    SET_NUMBER_OF_RESULTS(state, numberOfResults) {
        state.numberOfResults = numberOfResults;
    },
    SET_USER_PROCESS_DETAIL_DATA(state, data) {
        state.userProcessdetailData = data
    },
    SET_QUIZ_RESULTS(state, data) {
        state.quizResultsData = data
    }
}